import { jsx } from "@emotion/react/jsx-runtime";
import "react";
import ReactSelect from "react-select";
import normalizeOptions from "./normalizeOptions.mjs";
import { useThemeProps, ensureArray } from "@wsui/base";
import { useTheme } from "@emotion/react";
import omit from "lodash/fp/omit";
function Select(props) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "Select"
  });
  let {
    options,
    value,
    onChange,
    defaultValue,
    multiple = false,
    name,
    id,
    borderRadius = 1,
    padding = 3,
    paddingBlock = padding,
    // paddingInline = padding,
    ...restProps
  } = omit(["paddingInline"], props);
  let normalizedOptions = normalizeOptions(options);
  if (multiple) {
    normalizedOptions = normalizedOptions.filter(option => option.value !== "");
  }
  return /* @__PURE__ */jsx(ReactSelect, {
    name,
    id,
    options: normalizedOptions,
    isMulti: multiple,
    value: value === void 0 ? value : multiple ? value.map(value2 => normalizedOptions.find(option => option.value === value2)) : normalizedOptions.find(option => option.value === value),
    defaultValue: defaultValue === void 0 ? defaultValue : multiple ? defaultValue.map(value2 => normalizedOptions.find(option => option.value === value2)) : normalizedOptions.find(option => option.value === defaultValue),
    onChange: onChange && function (newValue) {
      newValue = multiple ? Array.isArray(newValue) ? newValue.map(option => typeof option === "object" ? option.value : option) : ensureArray(newValue && typeof newValue === "object" ? newValue.value : newValue) : newValue && typeof newValue === "object" ? newValue.value : newValue || "";
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      onChange({
        target: {
          name,
          id,
          value: newValue
        }
      }, newValue, ...args);
    },
    isClearable: true,
    styles: {
      control: styles => ({
        ...styles
      })
    },
    theme: componentTheme => ({
      ...componentTheme,
      borderRadius: theme.getLength(borderRadius),
      spacing: {
        ...componentTheme.spacing,
        controlHeight: `calc(${theme.getLength(paddingBlock)} * 2 + 1lh)`
      },
      colors: {
        ...componentTheme.colors,
        primary: theme.getColor("primary"),
        primary75: theme.getColor("primary.-100"),
        primary50: theme.getColor("primary.200"),
        primary25: theme.getColor("primary.100"),
        danger: theme.getColor("error"),
        dangerLight: theme.getColor("error.100"),
        neutral0: theme.getColor("gray.0"),
        neutral5: theme.getColor("gray.50"),
        neutral10: theme.getColor("gray.100"),
        neutral20: theme.getColor("gray.200"),
        neutral30: theme.getColor("gray.300"),
        neutral40: theme.getColor("gray.400"),
        neutral50: theme.getColor("gray.500"),
        neutral60: theme.getColor("gray.600"),
        neutral70: theme.getColor("gray.700"),
        neutral80: theme.getColor("gray.800"),
        neutral90: theme.getColor("gray.900")
      }
    }),
    ...restProps
  });
}
export { Select as default };